import { render, staticRenderFns } from "./detailDrCompetition.vue?vue&type=template&id=d24ccb38&scoped=true"
import script from "./detailDrCompetition.vue?vue&type=script&lang=js"
export * from "./detailDrCompetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24ccb38",
  null
  
)

export default component.exports